<template>
  <v-app>
<!--    <v-card class="mx-auto" color="grey-lighten-3">-->
      <v-layout>
        <!--        TODO move it to its own admin-components -->
        <v-navigation-drawer
            v-model="drawer"
            expand-on-hover
            :rail="$vuetify.display.mdAndUp"
            :temporary="$vuetify.display.smAndDown"
            :permanent="$vuetify.display.mdAndUp">
          <v-list v-if="userStore.isLoggedIn && userStore.uid">
            <v-list-item :prepend-avatar="SiteIcon"
                         :title="userStore.uid"
            >
            </v-list-item>
          </v-list>
          <v-divider></v-divider>
          <v-list density="compact" nav>
            <template v-if="userStore.isLoggedIn">
            <v-list-item prepend-icon="mdi-reload" title="Accueil" to="/home"></v-list-item>
            <v-list-item prepend-icon="mdi-church" title="La ceremonie" to="/ceremonie"></v-list-item>
            <v-list-item prepend-icon="mdi-home-circle" title="Le lieu" to="/lieu"></v-list-item>
            <v-list-item v-if="userStore.isSleeping" prepend-icon="mdi-bed" title="Le sejour" to="/sleep"></v-list-item>
            <v-list-item prepend-icon="mdi-calendar" title="La date" to="/date"></v-list-item>
            <v-list-item v-if="userStore.isDining" prepend-icon="mdi-silverware-fork-knife" title="Le menu" to="/menu"></v-list-item>
            <v-list-item prepend-icon="mdi-ticket" title="Les activites" to="/activity"></v-list-item>
              <v-list-item prepend-icon="mdi-camera" title="La galerie" to="/gallery"></v-list-item>
              <v-list-item prepend-icon="mdi-camera-plus" title="Ajouter une photo" to="/take-photo"></v-list-item>
            <v-list-item prepend-icon="mdi-plane-train" title="Le voyage" to="/noce"></v-list-item>
            <!--  <v-list-item prepend-icon="mdi-email-plus-outline" title="La reponse" to="/confirm"></v-list-item> -->
            <!--            <v-list-item prepend-icon="mdi-library" title="Livre d'or" to="/guestbook"></v-list-item>-->
            </template>
            <v-list-item v-else prepend-icon="mdi-login" title="Se connecter" to="/"></v-list-item>
          </v-list>
          <v-divider></v-divider>

        </v-navigation-drawer >
        <v-app-bar float border>
            <v-app-bar-nav-icon class="d-md-none" @click="drawer = !drawer">
            </v-app-bar-nav-icon>

<!--          <template v-slot:prepend v-if="$vuetify.display.mdAndUp">-->
<!--            <v-avatar size="32" class="ml-2">-->
<!--          <img alt="Vue logo" :src="SiteIcon" width="25" height="32"/>-->
<!--            </v-avatar>-->
<!--          </template>-->

          <v-app-bar-title class="text-subtitle-1 text-md-h6">
           {{ $vuetify.display.xs ? ' J & L ' : 'Mariage Jacques et Lucile' }}
          </v-app-bar-title>

<!--          <nav class="bg-amber py-4 sticky top-0 z-10 justify-center">-->
<!--            <div class="container mx-auto flex justify-center space-x-8">-->
<!--              <v-btn to="/" icon="mdi-home"/>-->
<!--              <span v-if="isLoggedIn">-->
<!--              <v-btn to="/feed" icon="mdi-rss"/>-->
<!--              <v-btn to="/addresses" icon="mdi-book-account"/>-->
<!--              <v-btn @click="signOut" icon="mdi-logout"/>-->
<!--      </span>-->
<!--              <span v-else>-->
<!--                <v-btn to="/register" icon="mdi-account-plus"/>-->
<!--                <v-btn to="/sign-in" icon="mdi-login"/>-->
<!--      </span>-->
<!--            </div>-->
<!--          </nav>-->
          <!-- Centered Navigation inside Bar -->
          <div class="flex space-x-1 mr-2">
            <v-btn to="/" icon="mdi-home" variant="text" size="small"/>
            <template v-if="userStore.isLoggedIn">
<!--              <v-btn to="/feed" icon="mdi-rss" variant="text" size="small"/>-->
<!--              <v-btn to="/addresses" icon="mdi-book-account" variant="text" size="small"/>-->
              <v-btn @click="signOut" icon="mdi-logout" variant="text" color="error" size="small"/>
            </template>
            <!--template v-else>
              <v-btn to="/register" icon="mdi-account-plus" variant="text" size="small"/>
              <v-btn to="/sign-in" icon="mdi-login" variant="text" size="small"/>
            </template-->
          </div>
        </v-app-bar>

        <v-main class="bg-grey-lighten-3">
          <v-container fluid class="pa-2 pa-sm-4 pa-md-6">
            <!--
     The :key="$route.fullPath" on router-view is crucial.
     It forces Vue Router to re-render the component whenever the full path changes.
     This ensures that if you navigate to the same component with different
     parameters (e.g., /users/1 and /users/2), the component will be fully
     re-initialized, triggering its lifecycle hooks like 'mounted' again.
   -->
            <div class="articles-wrapper mx-auto">
            <router-view :key="$route.fullPath"/>
            </div>
          </v-container>
        </v-main>

        <v-footer class="bg-grey-darken-4 text-amber-darken-3 justify-center text-caption" app>
          <div>
            Jacques et Lucile © 2024
          </div>
        </v-footer>

      </v-layout>
  </v-app>
</template>

<script setup>
import {ref} from 'vue' // used for conditional rendering
import {useRouter} from 'vue-router'
import SiteIcon from '@/assets/LogoMariage.png'
import {useUserStore} from "@/router/userStore";

const userStore = useUserStore();


const router = useRouter()
const drawer = ref(true)

const signOut = () => {
  userStore.logout()
  router.push('/')
}

</script>


<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0 !important;
}
/* 2. Ensure html and body occupy full height */
html, body {
  height: 100%;
  width: 100%;
  margin: 0;
  overflow: hidden; /* Let v-main handle the scrolling */
}
/* 3. Style the content area */
.articles-wrapper {
  width: 100%;
  max-width: 1200px;
  background: white;
  border: 1px solid #ddd;
  border-radius: 8px;
  min-height: calc(100vh - 120px); /* Stretch to fill the v-container */
  padding: 16px;
  box-shadow: 0 4px 16px rgba(0,0,0,0.05);
  text-align: center;
  height: calc(100vh - 150px);
  overflow-y: auto;
}

@media (min-width: 600px) {
  .articles-wrapper {
    padding: 32px;
  }
}

  /* Gestion du défilement fluide sur iOS */
.v-main {
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
}

/* If you specifically want a scrollable internal area instead of page scroll */
.articles-content-scroll {
  width: 100% !important;
  max-width: none !important;
}
</style>
